/**
 * Maps frontend table column accessors to backend sortBy field names
 */
export const mapSortColumnToBackend = (frontendColumn: string): string => {
  const columnMapping: Record<string, string> = {
    // Field name transformations
    account: "account",
    archivedAt: "archivedAt",
    assignee: "assignee_name",
    brand: "brand_name",
    // Date field mappings
    completedDate: "reviewed_at",
    complexity: "complexity",

    createdAt: "created_at",
    // Direct matches (no mapping needed)
    createdBy: "createdBy",
    designType: "designType",
    dueDate: "due_on",
    lastActivity: "updated_at",

    name: "name",
    order: "order",
    pausedAt: "pausedAt",
    // Rating and other fields (direct pass-through for now)
    rating: "rating",

    requestType: "request_type",
    status: "status_name",
  };

  return columnMapping[frontendColumn] || frontendColumn;
};

/**
 * Maps backend sortBy field names back to frontend column accessors
 * (mainly for debugging and consistency checks)
 */
export const mapSortColumnToFrontend = (backendColumn: string): string => {
  const reverseMapping: Record<string, string> = {
    // Reverse field name transformations
    account: "account",
    archivedAt: "archivedAt",
    assignee_name: "assignee",
    brand_name: "brand",

    complexity: "complexity",
    // Reverse date field mappings
    created_at: "createdAt",

    // Direct matches
    createdBy: "createdBy",
    designType: "designType",
    due_on: "dueDate",
    name: "name",

    order: "order",
    pausedAt: "pausedAt",
    // Other fields
    rating: "rating",
    request_type: "requestType",

    reviewed_at: "completedDate",
    status_name: "status",
    updated_at: "lastActivity",
  };

  return reverseMapping[backendColumn] || backendColumn;
};
